import { render } from "./NavbarHome.vue?vue&type=template&id=22a79e34"
import script from "./NavbarHome.vue?vue&type=script&lang=js"
export * from "./NavbarHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__